<div class="modal brightness">
  <div class="close-link">
    <span class="close" (click)="onCloseClick()"></span>
  </div>
  <div class="title-wrap">
    <h1 matTooltip="{{'pages.tables.modal.brightness.info' | translate}}">
      {{ 'pages.tables.modal.brightness.title' | translate }}
      <span class="info_icon">ⓘ</span>
    </h1>

    <mat-slide-toggle
      color="primary"
      [(ngModel)]="enableSchedule"
      (change)="onScheduleToggle($event)"
    >
      {{ 'pages.tables.actions.brightnessScheduleToggle' | translate }}
    </mat-slide-toggle>
  </div>

  <app-period
    *ngFor="let period of brightnessSchedule"
    [period]="period"
    [periods]="brightnessSchedule"
    periodType="brightness"
    [editable]="editable"
    (update)="updatePeriod($event)"
    (delete)="deletePeriod($event)"
    (isEdited)="this.isSomePeriodEdited = $event"
  >
  </app-period>

  <div class="periods__skeleton" *ngIf="loading">
    <ngx-skeleton-loader
      count="3"
      appearance="line"
      [theme]="{ height: '90px', 'margin-bottom': '10px', 'border-radius': '10px' }">
    </ngx-skeleton-loader>
  </div>

  <div class="period__empty" *ngIf="!isEditPeriods">
    <span class="noPeriods" *ngIf="!loading && !isEditPeriods && !brightnessSchedule.length">{{ 'period.brightness.noPeriods' | translate }}</span>
    <button class="btn btn__primary btn__icon" *ngIf="!isEditPeriods && editable" (click)="isEditPeriods = true">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 1V15" stroke="currentColor" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>
        <path d="M0.999878 8H14.9999" stroke="currentColor" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>
      </svg>
      <span class="add">{{ 'period.brightness.add' | translate }}</span>
    </button>
  </div>

  <app-period
    *ngIf="isEditPeriods"
    [periods]="brightnessSchedule"
    periodType="brightness"
    (newPeriod)="createPeriod($event)"
    (cancel)="isEditPeriods = $event"
  >
  </app-period>

</div>
